import { render, staticRenderFns } from "./BannersIndex.vue?vue&type=template&id=9ec62670&"
import script from "./BannersIndex.vue?vue&type=script&lang=js&"
export * from "./BannersIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports